<div class="UNFAPP-signlog-full-area">
    <div class="UNFAPP-signlog-frm-wrpbx">
        <div class="UNFAPP-signlog-frmbx">

            <div class="UNFAPP-signlog-hdng-wrap">
                <h2 class="UNFAPP-signlog-hdng">Welcome to Infinity Learn</h2>
                <h3 class="UNFAPP-signlog-stphdng">You are 2 steps away from
                    starting your learning journey</h3>
            </div>

            <div class="UNFAPP-signlog-form-area" [formGroup]='signupForm'>

                <div *ngIf="checkIlDefaultFields()">
                    <div class="UNFAPP-form-fld-row">
                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                            <span class="UNFAPP-frmicon"><img
                                    src="assets/img/name-icon.png" alt="" /></span>
                            <input type="text" class="UNFAPP-form-fld"
                                formControlName='firstName' placeholder="First Name">
                        </div>
                    </div>

                    <div class="UNFAPP-form-fld-row">
                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                            <span class="UNFAPP-frmicon"><img
                                    src="assets/img/name-icon.png" alt="" /></span>
                            <input type="text" class="UNFAPP-form-fld"
                                formControlName='lastName' placeholder="Last Name">
                        </div>
                    </div>
                </div>
                <div class="UNFAPP-signlog-grdarea">
                    <h3 class="UNFAPP-signlog-hdng sm-hdng">What grade are you
                        in?</h3>

                    <ul class="UNFAPP-grdlist-area">
                        <ng-container *ngFor="let grade of grades">
                            <li>
                                <label class="UNFAPP-grd-radio">
                                    <input type="radio" name="grade"
                                        [checked]='checked(grade)'
                                        (click)="selectedGrade(grade)">
                                    <div *ngIf="grade.name != '13th'"
                                        class="UNFAPP-grd-radiobx">{{grade?.name?.slice(0,-2)}}
                                    </div>
                                    <div *ngIf="grade.name == '13th'"
                                        class="UNFAPP-grd-radiobx">{{grade?.name?.slice(0,-2)}}
                                        <span class="UNFAPP-update-txt s13">(Repeater)
                                        </span></div>
                                </label>
                            </li>
                        </ng-container>
                    </ul>
                </div>


                <!-- <div class="UNFAPP-update-txt text-center">
                    <label class="whtapp-custom-checkbox">
                        <input type="checkbox"
                            formControlName='whatsappConsent'> <span>Receive
                            updates on Whatsapp</span></label>
                </div>
                <p class="UNFAPP-terms-text">By signing up you agree to our <a
                        (click)="openTermsAndConditionsDialog()">T&C</a> and <a
                        (click)='openPrivacyPolicyDialog()'>Privacy Policy</a>
                </p> -->

                <div class="UNFAPP-frm-actn-area">
                    <button class="UNFAPP-blue-btn UNFAPP-full-btn"
                        [disabled]='!signupForm.valid' (click)="goToExam()">NEXT</button>
                </div>
            </div>
        </div>
    </div>
</div>